import React, { useState } from "react";

import ArrowRight from "../components/ArrowRight";
import AlreadyHaveAccount from "../components/AlreadyHaveAccount";
import BuildingIcon from "../components/BuildingIcon";
import PhoneIcon from "../components/PhoneIcon";
import { isFullPhoneNumberValid } from "../../../_services/phone-utils";

// Phone validation (ticket #42120): validate with the shared phone-utils helper so the frontend
// matches the backend's Google libphonenumber isValidNumber() (region DE) exactly — a number that
// passes here will pass PhoneNumberValidationHelper on the org. Empty is always valid (optional field).
const isPhoneValid = (value) => isFullPhoneNumberValid(value);

/**
 * Step 2 — "Wie heißt dein Unternehmen?"
 * Company name (stored as the organisation name) + optional phone number (ticket #42120).
 * "Weiter" requires only the company name; an empty phone never blocks the flow, but a
 * non-empty invalid phone does (with an inline error).
 */
const CompanyNameStep = ({ companyName, setCompanyName, phoneNumber, setPhoneNumber, onNext }) => {
    const [phoneTouched, setPhoneTouched] = useState(false);

    const phoneValid = isPhoneValid(phoneNumber);
    const showPhoneError = phoneTouched && phoneNumber.trim().length > 0 && !phoneValid;
    const canProceed = companyName.trim().length > 0 && phoneValid;

    const submit = (e) => {
        e.preventDefault();
        setPhoneTouched(true);
        if (canProceed) onNext();
    };

    return (
        <form className="registration-step registration-step--company" onSubmit={submit} data-cy="registration-step-company">
            <p className="registration-step__eyebrow">Fast geschafft</p>
            <h1 className="registration-step__title">Wie heißt dein Unternehmen?</h1>

            <div className="registration-field">
                <span className="registration-field__icon">
                    <BuildingIcon />
                </span>
                <input
                    type="text"
                    className="registration-input registration-input--with-icon"
                    placeholder="Name deines Unternehmens"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                    autoFocus
                    data-cy="registration-company-input"
                />
            </div>

            <div className="registration-field">
                <span className="registration-field__icon">
                    <PhoneIcon />
                </span>
                <input
                    type="tel"
                    className="registration-input registration-input--with-icon"
                    placeholder="Telefonnummer (optional)"
                    aria-label="Telefonnummer (optional)"
                    aria-invalid={showPhoneError}
                    aria-describedby={showPhoneError ? "registration-phone-error-msg" : undefined}
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    onBlur={() => setPhoneTouched(true)}
                    data-cy="registration-phone-input"
                />
            </div>
            {showPhoneError && (
                <p className="registration-input__error" id="registration-phone-error-msg" role="alert" data-cy="registration-phone-error">
                    Bitte gib eine gültige Telefonnummer ein (z.B. +49 170 1234567).
                </p>
            )}

            <button
                type="submit"
                className="registration-cta"
                disabled={!canProceed}
                data-cy="registration-company-next"
            >
                Weiter <ArrowRight />
            </button>

            <AlreadyHaveAccount />
        </form>
    );
};

export default CompanyNameStep;
